export default "<iframe width=\"100%\" height=\"100%\" style=\"border:none;\" [src]=\"iframeUrl\"></iframe>"